import React from 'react';
import { Link } from 'react-router-dom'

const Home = () => {

  return (
    <section className="section">
      <div className="container">
        <section className="hero has-text-centered">
          <div className="hero-body">
            <div className="container">
              <h1 className="title">
                Take notes while off the grid
              </h1>
              <Link to="create"className="button is-info is-large">Create New</Link> <Link to="notes" className="button is-link is-large">View Previous</Link>
            </div>
          </div>
        </section>
        <section className="section">
          <div className="content">
            <h2 className="subtitle">Introduction &amp; Objective</h2>
            <p>Hello,</p>
            <p>My name is <a className="is-link is-info" href="http://benschaaf.com" target="_blank">Ben Schaaf</a> and I created this project as an exercise in demostrating several technologies:</p>
            <ol>
              <li>React, React Router</li>
              <li>Redux</li>
              <li>ES6</li>
              <li>LocalStorage</li>
              <li>Service Workers (for Offline)</li>
            </ol>

            <p>My objective was to create a note taking application that would function even while the user was offline.</p>

            <h2 className="subtitle">Disclaimers</h2>
            <p>This application is <i>not</i> a finished project. There are several features which I would address over time. Below is my list of prioritized next-up tasks.</p>
            <ul>
              <li className="task task-complete">All data is currently only stored in LocalStorage. This is only due to time limitations. In the future, a user would sync their notes when online. When offline, items would be queued until the online conectivity is returned. <i>(Effort: 5 points)</i></li>
              <li>The app has not been tested thoroughly, unit or otherwise. I developed the site using Chrome on a MacBookPro. Next up: Add prop types and testing frameworks. <i>(Effort: 5 points)</i></li>
              <li className="task task-new">I bumped heads with Bulma and need to spend a couple hours sorting through some styles and helpers. <i>(Effort: 3 points)</i></li>
              <li className="task task-new">Refactor Redux actions and reducers. They work, but could be streamlined. <i>(Effort: 3 points)</i></li>
              <li>The offline experience should be improved. It is my intention to add notifications and alternative flows for offline users. <i>(Effort: 2 points)</i></li>
              <li>Currently when viewing posted notes, there is a very limited filter. In the future, a user should be able to sort by tag or by text. <i>(Effort: 5 points)</i></li>


            </ul>

            <h2 className="subtitle">Tools &amp; Frameworks</h2>
            <p>I used several libraries when creating this microsite, including:</p>
            <ul>
              <li>Javascript framework: React (an ejected create-react-app)</li>
              <li>Grid framework: Bulma</li>
            </ul>

            <h2 className="subtitle">Thanks for your interest!</h2>
            <p>Please feel free to contact me ben at benschaf dot com</p>
          </div>
          </section>
      </div>
    </section>
  )
}

export default Home;



// WEBPACK FOOTER //
// ./src/Pages/home.js